import React, {Component} from 'react';
import { Select, message } from 'antd';
import {fetch, post} from "../../../utils/axios_utils";
import Cookies from 'js-cookie'
const { Option } = Select;

export default class Path extends Component {
    state = {
        loading: false,
        projectData: [],
        accountSetId: Cookies.get('accountSetId'),
        userData: '',
        params: {
            name: '',
            size: 999,
            page: 0
        },
    };
    componentDidMount() {
        this.getProjects()
    }
    getProjects =()=>{
        let { accountSetId } = this.state
        fetch('/config/account_set/list', { page: 0, size: 999, sort: 'createdAt' })
            .then(res => {
                if (res.success) {
                    if (!accountSetId && res.data.content.length !== 0){
                        Cookies.set('accountSetId', res.data.content[0].id)
                        this.setState({
                            accountSetId: res.data.content[0].id
                        })
                    }
                    this.setState({
                        projectData: res.data.content,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            }).finally(() => this.setState({loading: false}));
    }
    onSelect =(e)=> {
        const {action: {system}} = this.props;
        let { projectData } = this.state
        let current = projectData.find(item => item.id === e)
        if (current) {
            Cookies.set('subjectLevel', current.encoding.length, {expires: 1}); // 科目级次
            Cookies.set('currentAccountDate', current.currentAccountDate)
            Cookies.set('accountingStandard', current.accountingStandard.value)
        }
        Cookies.set('accountSetId', e)
        let params = {
            token: `${Cookies.get('plant01_token_type')} ${Cookies.get('plant01_token')}`,
            accountSetId: e
        }
        post('/system/token/update_token', params).then(res => {
            if (res.success) {
                Cookies.set('plant01_token', res.data.token, {expires: 1});
                Cookies.set(window.tokenKey, `bearer ${res.data.token}`, { expires: 7 });
                Cookies.set('accountSetId', e)
                this.setState({ accountSetId: e })
                system.closeAllTabs()
                if (this.props.location.pathname === '/') {
                    window.location.reload()
                }
            }
        }).catch(err => {
            console.log(err)
        })
    }
    render() {
        const { projectData, accountSetId } = this.state
        const {className} = this.props;
        return (
            <div className={className} style={{width: 250}}>
                {
                    projectData.length !==0 ? <Select value={accountSetId} style={{ width: 250 }} onSelect={this.onSelect}>
                        {
                            projectData.map(item => {
                                return <Option
                                    value={item.id}
                                    key={item.id}>
                                    <div>{item.companyName}</div>
                                </Option>
                            })
                        }
                    </Select> : null
                }

            </div>
        );
    }
}
